const { search } = window.location;
export const uuidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;
const accessToken = uuidRegex.test(search) ? search.match(uuidRegex)[0] : 'a619bbff-1ab8-4a56-83b0-425759c2da76';

const sessionBankId = () => {
	switch (process.env.BRAND_ID) {
		case 'VM':
			return 'CB';
		default:
			return process.env.BRAND_ID;
	}
};

export default {
	clientContext: {
		client: {
			user_tracking_id: '1a4e5020-2dc4-11e8-8f6e-594d2776aa92',
			app_title: 'CB Web',
			app_package_name: 'BWEB',
			app_version_code: '1.0.0',
			app_version_name: 'Milestone_1',
		},
		env: {
			platform_version:
				'5.0 (Macintosh; Intel Mac OS X 10_12_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/65.0.3325.162 Safari/537.36',
			make: 'MacIntel',
			locale: 'en-GB',
			device_name: 'baadc3fa6e327e63e1c4cdf3da7ce3e2',
			platform: 'B Web',
		},
	},
	accessToken,
	bankId: process.env.NODE_ENV === 'development' ? sessionBankId() : 'CB',
};
